<label>Number Active Users:</label>
<label>{{activeUserCount}}</label>
<br>
<br>
<label>Figure out what else we want on this page later, when we are otherwise done the things.</label>
